import { QuotationStatus } from '../interfaces/invoice.interface';

const QUOTATION_STATUSES_EDITABLE = new Set<string>(
  [QuotationStatus.Draft, QuotationStatus.Sent, QuotationStatus.None].map((s) =>
    s.toLowerCase(),
  ),
);

/**
 * Offer price documents are editable in the UI only while in preparatory workflow states.
 * Comparison is case-insensitive to tolerate API serialization differences.
 */
export function isQuotationStatusEditable(
  status: string | undefined | null,
): boolean {
  if (status === undefined || status === null) {
    return true;
  }
  const normalized = String(status).trim().toLowerCase();
  if (normalized === '') {
    return true;
  }
  return QUOTATION_STATUSES_EDITABLE.has(normalized);
}
